export function isArabic(text) {
  // Regular expression to match Arabic characters
  var arabicRegex = /[\u0600-\u06FF]/;

  // Test if the text contains Arabic characters
  return arabicRegex.test(text);
}
